module.exports = __webpack_public_path__ + "controlmanage.jpg?60236600bdba19897da7576849a6ba1d";


//////////////////
// WEBPACK FOOTER
// ./static/images/controlmanage.jpg
// module id = 24
// module chunks = 0 1